import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';

interface SignupTestOrgLandingResponse {
  org_id: number | null;
}

/**
 * One-shot fetch of the signup-test-org landing hint.
 *
 * When an allowlisted account enters via the invite-code signup handshake, the
 * user_logged_in signal (apps/orgs/signals.py) mints a fresh org and stashes its
 * id in the session. This endpoint returns that id once and clears it, so the SPA
 * can route the user into the fresh org. The common case (any ordinary login)
 * returns `{ org_id: null }`.
 *
 * Consumed by HomeRedirect — the post-login landing decision point — because the
 * social-OAuth callback is a full-page load that never emits a LOGGED_IN
 * transition event.
 */
export function useSignupTestOrgLanding(enabled: boolean) {
  return useQuery({
    queryKey: ['signup-test-org-landing'],
    queryFn: () =>
      apiGet<SignupTestOrgLandingResponse>('/orgs/api/signup-test-org/'),
    enabled,
    // The endpoint is one-shot (server pops the hint), so never refetch or cache.
    staleTime: Infinity,
    gcTime: 0,
    retry: false,
  });
}
